/**
 * Coarse landmass outlines, hand-authored for this site.
 *
 * These are deliberately low-fidelity approximations drawn to be recognisable
 * at a few hundred pixels — they are not derived from any licensed cartographic
 * dataset. Each entry is a closed ring of [longitude, latitude] pairs.
 */

export const LANDMASSES = [
  // North America
  [
    [-168, 65], [-162, 71], [-140, 70], [-125, 70], [-110, 68], [-95, 70],
    [-85, 73], [-75, 76], [-62, 74], [-56, 66], [-62, 58], [-66, 50],
    [-55, 47], [-66, 44], [-71, 41], [-76, 35], [-81, 25], [-90, 29],
    [-97, 26], [-105, 22], [-110, 23], [-115, 30], [-122, 37], [-125, 45],
    [-130, 55], [-140, 60], [-150, 60], [-162, 58],
  ],
  // Central America bridge
  [
    [-92, 18], [-84, 15], [-77, 8], [-79, 6], [-86, 12], [-95, 16],
  ],
  // Greenland
  [
    [-45, 60], [-22, 70], [-20, 81], [-40, 84], [-58, 80], [-56, 66],
  ],
  // South America
  [
    [-81, 8], [-73, 11], [-60, 11], [-50, 2], [-35, -5], [-35, -22],
    [-48, -25], [-58, -35], [-62, -41], [-68, -53], [-75, -50], [-73, -40],
    [-71, -30], [-70, -18], [-77, -5],
  ],
  // Africa
  [
    [-17, 15], [-12, 28], [0, 32], [10, 37], [20, 32], [32, 31], [35, 25],
    [43, 12], [51, 12], [42, -2], [40, -15], [35, -25], [25, -34], [18, -34],
    [12, -18], [9, -2], [0, 5], [-8, 5],
  ],
  // Madagascar
  [
    [44, -12], [50, -16], [47, -25], [43, -22], [43, -16],
  ],
  // Europe and Asia, including the Indian peninsula
  [
    [-10, 36], [-9, 43], [-2, 48], [3, 51], [6, 58], [12, 57], [16, 68],
    [28, 71], [40, 68], [55, 70], [70, 72], [85, 75], [100, 76], [115, 74],
    [130, 72], [142, 70], [160, 68], [178, 66], [172, 60], [162, 58],
    [150, 59], [142, 53], [135, 45], [128, 38], [122, 30], [112, 22],
    [105, 10], [100, 5], [97, 16], [92, 21], [88, 21], [85, 19], [80, 13],
    [77, 8], [73, 16], [70, 21], [64, 25], [58, 24], [50, 29], [45, 38],
    [40, 41], [35, 36], [28, 36], [20, 40], [15, 38], [12, 45], [5, 43],
    [-5, 36],
  ],
  // British Isles
  [
    [-10, 51], [-2, 51], [0, 54], [-2, 58], [-8, 57], [-10, 54],
  ],
  // Japan
  [
    [130, 31], [136, 34], [141, 38], [145, 44], [141, 45], [136, 37],
    [131, 33],
  ],
  // Indonesia and the Philippines, roughly
  [
    [95, 5], [105, 2], [118, 1], [128, 1], [140, -3], [138, -8], [125, -9],
    [112, -8], [100, -2],
  ],
  // Australia
  [
    [113, -22], [115, -33], [125, -33], [135, -35], [145, -38], [150, -35],
    [153, -28], [146, -19], [140, -17], [135, -12], [130, -12], [125, -15],
    [118, -20],
  ],
  // New Zealand
  [
    [172, -35], [176, -38], [178, -39], [174, -42], [168, -46], [166, -45],
    [170, -41],
  ],
];

/**
 * Ray-casting point-in-polygon test on the [lon, lat] plane.
 * Good enough away from the poles and the antimeridian, which is all this
 * decorative globe needs.
 */
export function isLand(lon, lat) {
  for (let p = 0; p < LANDMASSES.length; p += 1) {
    const ring = LANDMASSES[p];
    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i, i += 1) {
      const [xi, yi] = ring[i];
      const [xj, yj] = ring[j];
      const straddles = yi > lat !== yj > lat;
      if (straddles && lon < ((xj - xi) * (lat - yi)) / (yj - yi) + xi) {
        inside = !inside;
      }
    }
    if (inside) return true;
  }
  return false;
}
